import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteSingleClothStock } from '../../../Store/PHPSlice/clothStock';
import { deleteStockProduction } from '../../../Store/PHPSlice/Stock/StockApis';

const TableBody = ({
    serialNumber,
    id,
    dt,
    icode,
    departNm,
    qty,
    stk_memo,
    itemId,
    itemNm,
    contraId,
    ctMemo,
    stitchId,
    stMemo,
    size,
    pksts,
    sts,
    barcode,
    soId,
    sono,
    mclothNm,
    m1clothNm,
    m2clothNm,
    m3clothNm,
    color,
    inwqty,
    balqty,
    rackNm,
    locNm,
    sqty,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();
    // const getDelete = useSelector((state) => state.companyData.deleteComp);
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/StkProductionEdit/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const userId = '1';

    function obj(id, icode, size, qty, streId, ctreId, userId) {
        const data = {
            stkId: id,
            icode: icode,
            size: size,
            stitchId: stitchId,
            contraId: contraId,
            qty: qty,
            userId: userId
        };
        return data;
    };

    const handleDeleteClick = () => {
        // Show confirmation dialog
        const postData = obj(id, icode, size, qty, stitchId, contraId);

        const isConfirmed = window.confirm("Are you sure you want to delete this Stock?");

        // // If user confirms, proceed with deletion
        if (isConfirmed) {
            dispatch(deleteStockProduction(postData))
                .then(() => {
                    // Reload the page to show updated results
                    toast("Stock Deleted");
                    window.location.reload();
                })
                .catch((error) => {
                    // Handle any errors that occur during the deletion process
                    console.error("Error deleting Item:", error);
                    toast.error("Failed to delete Item");
                });
        }
    };

    var itemName = itemNm;
    if (mclothNm !== '-') {
        itemName = `${itemNm} - ${mclothNm}`;
    }
    if (m1clothNm !== '-') {
        itemName = `${itemNm} - ${mclothNm}, ${m1clothNm}`;
    }
    if (m2clothNm !== '-') {
        itemName = `${itemNm} - ${mclothNm}, ${m1clothNm}, ${m2clothNm}`;
    }
    if (m3clothNm !== '-') {
        itemName = `${itemNm} - ${mclothNm}, ${m1clothNm}, ${m2clothNm}, ${m3clothNm}`;
    }

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {serialNumber}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {dt}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {stk_memo}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {sono}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {barcode}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {itemName}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {color}
                </TableCell>

                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {stMemo}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {ctMemo}
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {departNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {size}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {qty}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {sqty}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {balqty}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {locNm === '0' ? '-' : locNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {rackNm === '0' ? '-' : rackNm}
                </TableCell>

                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <EditIcon className={`cursor-pointer ${sts === '1' && pksts === '1' ? 'disabled-icon' : ''}`} onClick={handleEditClick} />
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${sts === '1' && pksts === '1' ? 'disabled-icon' : ''}`} onClick={handleDeleteClick} />
                </TableCell> */}


            </TableRow>
        </>
    );
};

export default React.memo(TableBody);
